import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart-icon-outline",
  "use": "icon-heart-icon-outline-usage",
  "viewBox": "0 0 17.63 15.85",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.63 15.85\" id=\"icon-heart-icon-outline\"><path d=\"M8.02 15.03c.21.21.49.32.78.32.29 0 .57-.12.78-.32l6.14-6.14a4.931 4.931 0 0 0-.07-6.98 4.93 4.93 0 0 0-6.85-.05C6.8 0 3.68.11 1.82 2.11a4.929 4.929 0 0 0 .05 6.77l6.15 6.15Z\" style=\"fill:#fff;stroke:#afafaf;stroke-miterlimit:10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol